// Query key factory for React Query - no hardcoded strings
export const validationKeys = {
  all: ['validation'] as const,
  check: (email: string) => [...validationKeys.all, 'check', email] as const,
  matrix: (email: string) => [...validationKeys.all, 'matrix', email] as const,
};

export const providerKeys = {
  all: ['providers'] as const,
  list: () => [...providerKeys.all, 'list'] as const,
};

export const healthKeys = {
  all: ['health'] as const,
  readiness: () => [...healthKeys.all, 'readiness'] as const,
  liveness: () => [...healthKeys.all, 'liveness'] as const,
};

export const featuresKeys = {
  all: ['features'] as const,
  flags: () => [...featuresKeys.all, 'flags'] as const,
};
